import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { PaginatorModule } from 'primeng/paginator';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DataSourcesFileFormatList } from '../../lists/data-sources-file-format.list';
import { DataSourcesFileSeparatorList } from '../../lists/data-sources-file-separator.list';
import { DataSourcesAdditionsComponent } from '../data-source-additions/data-sources-additions.component';
import { DataSourceUniqueNameComponent, DataSourceVisibilityComponent } from '../data-source-form-inputs';
import { DataSourcesBasic } from '../data-sources-basic';

@Component({
    selector: 'selfai-platform-data-sources-hdfs',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        ButtonModule,
        CheckboxModule,
        InputTextModule,
        PaginatorModule,
        RadioButtonModule,
        DataSourcesAdditionsComponent,
        DataSourceUniqueNameComponent,
        DataSourceVisibilityComponent,
    ],
    templateUrl: './data-sources-hdfs.component.html',
    styleUrls: ['./data-sources-hdfs.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DataSourcesHdfsComponent extends DataSourcesBasic implements OnInit {
  format = DataSourcesFileFormatList;
  separators = DataSourcesFileSeparatorList;
  customParamsVisible = true;

  paramsForm = this.fb.group({
    hdfsPath: ['', Validators.required],
    fileFormat: ['csv'],
    csvFileFormatParams: this.fb.group({
      convert01ToBoolean: [false],
      includeHeader: [false],
      separatorType: ['comma'],
      customSeparator: [''],
    }),
  });

  constructor() {
    super('hdfs');
  }

  changeFormat(value: string): void {
    this.customParamsVisible = value === 'csv';
  }
}
